import classNames from "classnames"
import React, { useState } from "react"

import { useTranslation } from "../../../i18n/translate"
import AdditiveTooltip from "../../additive-tooltip/additive-tooltip"
import Tile from "../../tile/tile"
import "./what-are-additives.sass"

const WhatAreAdditives = () => {
  const [showAllPoints, setShowAllPoints] = useState(false)

  const info = [
    {
      number: 1,
      position: { x: "90%", y: "30%" },
      titleTranslationKey:
        "CAREER-MUNZING_AS_EMPLOYER-WHAT_ARE_ADDITIVES-POINT_1-TITLE",
      descriptionTranslationKey:
        "CAREER-MUNZING_AS_EMPLOYER-WHAT_ARE_ADDITIVES-POINT_1-DESCRIPTION",
    },
    {
      number: 2,
      position: { x: "44%", y: "18%" },
      titleTranslationKey:
        "CAREER-MUNZING_AS_EMPLOYER-WHAT_ARE_ADDITIVES-POINT_2-TITLE",
      descriptionTranslationKey:
        "CAREER-MUNZING_AS_EMPLOYER-WHAT_ARE_ADDITIVES-POINT_2-DESCRIPTION",
    },
    {
      number: 3,
      position: { x: "41%", y: "74%" },
      titleTranslationKey:
        "CAREER-MUNZING_AS_EMPLOYER-WHAT_ARE_ADDITIVES-POINT_3-TITLE",
      descriptionTranslationKey:
        "CAREER-MUNZING_AS_EMPLOYER-WHAT_ARE_ADDITIVES-POINT_3-DESCRIPTION",
    },
    {
      number: 4,
      position: { x: "80%", y: "37%" },
      titleTranslationKey:
        "CAREER-MUNZING_AS_EMPLOYER-WHAT_ARE_ADDITIVES-POINT_4-TITLE",
      descriptionTranslationKey:
        "CAREER-MUNZING_AS_EMPLOYER-WHAT_ARE_ADDITIVES-POINT_4-DESCRIPTION",
    },
    {
      number: 5,
      position: { x: "90%", y: "89%" },
      titleTranslationKey:
        "CAREER-MUNZING_AS_EMPLOYER-WHAT_ARE_ADDITIVES-POINT_5-TITLE",
      descriptionTranslationKey:
        "CAREER-MUNZING_AS_EMPLOYER-WHAT_ARE_ADDITIVES-POINT_5-DESCRIPTION",
    },
    {
      number: 6,
      position: { x: "60%", y: "65%" },
      titleTranslationKey:
        "CAREER-MUNZING_AS_EMPLOYER-WHAT_ARE_ADDITIVES-POINT_6-TITLE",
      descriptionTranslationKey:
        "CAREER-MUNZING_AS_EMPLOYER-WHAT_ARE_ADDITIVES-POINT_6-DESCRIPTION",
    },
    {
      number: 7,
      position: { x: "20%", y: "31%" },
      titleTranslationKey:
        "CAREER-MUNZING_AS_EMPLOYER-WHAT_ARE_ADDITIVES-POINT_7-TITLE",
      descriptionTranslationKey:
        "CAREER-MUNZING_AS_EMPLOYER-WHAT_ARE_ADDITIVES-POINT_7-DESCRIPTION",
    },
    {
      number: 8,
      position: { x: "23%", y: "59%" },
      titleTranslationKey:
        "CAREER-MUNZING_AS_EMPLOYER-WHAT_ARE_ADDITIVES-POINT_8-TITLE",
      descriptionTranslationKey:
        "CAREER-MUNZING_AS_EMPLOYER-WHAT_ARE_ADDITIVES-POINT_8-DESCRIPTION",
    },
    {
      number: 9,
      position: { x: "60%", y: "31%" },
      titleTranslationKey:
        "CAREER-MUNZING_AS_EMPLOYER-WHAT_ARE_ADDITIVES-POINT_9-TITLE",
      descriptionTranslationKey:
        "CAREER-MUNZING_AS_EMPLOYER-WHAT_ARE_ADDITIVES-POINT_9-DESCRIPTION",
    },
  ]
  const { t } = useTranslation()

  return (
    <div className={"_fp-what-are-additives"}>
      <Tile
        titleTranslatedString={t(
          "CAREER-MUNZING_AS_EMPLOYER-WHAT_ARE_ADDITIVES-TITLE",
        )}
      >
        <div className={"_fp-what-are-additives__text"}>
          <p className={"_fp-text _fp-what-are-additives__text__copy"}>
            {t("CAREER-MUNZING_AS_EMPLOYER-WHAT_ARE_ADDITIVES-DESCRIPTION")}
          </p>
        </div>

        <div className="_fp-what-are-additives__image">
          <img
            src="/images/career/what-are-additives.jpg"
            alt={t("CAREER-MUNZING_AS_EMPLOYER-WHAT_ARE_ADDITIVES-DESCRIPTION")}
          />
          <div className="_fp-what-are-additives__image__spots">
            {info.map((i, index) => {
              return (
                <div
                  key={index}
                  style={{ left: i.position.x, top: i.position.y }}
                  data-tip={`<h5 class='_fp-heading-5'>${t(
                    i.titleTranslationKey,
                  )}</h5><p class='_fp-text'>${t(
                    i.descriptionTranslationKey,
                  )}</p>`}
                  data-iscapture="true"
                  className={"_fp-what-are-additives__image__spots__spot"}
                >
                  <p>{i.number}</p>
                </div>
              )
            })}
          </div>
        </div>
        <div
          className={classNames("_fp-what-are-additives__spots", {
            "_fp-what-are-additives__spots--show-all": showAllPoints,
          })}
        >
          {info.map((i, index) => {
            return (
              <div
                key={index}
                className={"_fp-what-are-additives__spots__spot"}
              >
                <div className={"_fp-what-are-additives__spots__spot__circle"}>
                  <p>{i.number}</p>
                </div>
                <div className={"_fp-what-are-additives__spots__spot__content"}>
                  <h5 className="_fp-heading-5 _fp-what-are-additives__spots__spot__content__title">
                    {t(i.titleTranslationKey)}
                  </h5>
                  <p className="_fp-text _fp-what-are-additives__spots__spot__content__text">
                    {t(i.descriptionTranslationKey)}
                  </p>
                </div>
              </div>
            )
          })}
          {!showAllPoints && (
            <div
              onClick={() => setShowAllPoints(true)}
              className="_fp-what-are-additives__spots__show-more _fp-heading-5"
            >
              {t("GLOBAL-READ_MORE")}
            </div>
          )}
        </div>

        <AdditiveTooltip />
      </Tile>
    </div>
  )
}

export default WhatAreAdditives
